/* Casa Lizette — cart drawer: fetch-based add/update, re-rendered via Section Rendering API. No framework. */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var drawer, overlay, body, countEls;

  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    countEls = qsa('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = count; });
  }

  function refreshDrawerMarkup() {
    return fetch('/?sections=' + SECTION_ID)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        var newOverlay = doc.querySelector('[data-cart-drawer-overlay]');
        if (newDrawer && drawer) drawer.innerHTML = newDrawer.innerHTML;
        if (newOverlay && overlay) overlay.outerHTML = newOverlay.outerHTML;
        overlay = qs('[data-cart-drawer-overlay]');
        bindDrawerInternalEvents();
      });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawerMarkup();
      })
      .then(function () { openDrawer(); });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawerMarkup();
      });
  }

  function bindDrawerInternalEvents() {
    var closeBtn = qs('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    qsa('[data-cart-item]').forEach(function (row) {
      var line = row.getAttribute('data-line');
      var qtyValue = row.querySelector('[data-cart-qty-value]');
      var increase = row.querySelector('[data-cart-qty-increase]');
      var decrease = row.querySelector('[data-cart-qty-decrease]');
      var remove = row.querySelector('[data-cart-remove]');

      if (increase) {
        increase.addEventListener('click', function () {
          var qty = parseInt(qtyValue.textContent, 10) + 1;
          changeLine(line, qty);
        });
      }
      if (decrease) {
        decrease.addEventListener('click', function () {
          var qty = parseInt(qtyValue.textContent, 10) - 1;
          changeLine(line, qty);
        });
      }
      if (remove) {
        remove.addEventListener('click', function () {
          changeLine(line, 0);
        });
      }
    });
  }

  function bindAddToCartForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      var data = new FormData(form);
      var payload = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshDrawerMarkup();
        })
        .then(function () {
          openDrawer();
          if (submitBtn) submitBtn.disabled = false;
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = qs('[data-cart-drawer]');
    overlay = qs('[data-cart-drawer-overlay]');
    body = qs('[data-cart-drawer-body]');
    if (!drawer) return;

    qsa('[data-cart-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    bindDrawerInternalEvents();
    bindAddToCartForms();
  });
})();
